import { createTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { mapStateToProps } from "../store/helpers/mapState";

const myTheme =(settings) => (
    createTheme({

    root: {
        display: "flex",
    },
    palette: {
        primary: {
            main: "#1987c9",
        },
    },
    typography: {
        fontFamily: "Lato, Arial",
        fontSize: 12,
        h1: {
            fontFamily: "Lato, Arial",
            fontSize: 30,
            fontWeight: 700,
        },
        h2: {
            fontFamily: "Lato, Arial",
            fontSize: 20,
            fontWeight: 700,
            paddingBottom: 20,
        },
    },
    overrides: {
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: settings?.backgroundColorSecond ?? "#cef0e3",
            },
        },
        MuiDrawer:{
            paper: {
                backgroundColor: settings?.backgroundColorPrimary ?? "#198754",
            },
        },
    },
})
);
export default myTheme;

// export default myTheme;
